import { useSyncExternalStore } from 'react';
import { PHONE_MEDIA_QUERY, TABLET_MEDIA_QUERY } from '../constants/breakpoints';
function resolveBreakpoint() {
  if (window.matchMedia(PHONE_MEDIA_QUERY).matches) return 'phone';
  if (window.matchMedia(TABLET_MEDIA_QUERY).matches) return 'tablet';
  return 'desktop';
}
function subscribe(onChange) {
  const phoneList = window.matchMedia(PHONE_MEDIA_QUERY);
  const tabletList = window.matchMedia(TABLET_MEDIA_QUERY);
  phoneList.addEventListener('change', onChange);
  tabletList.addEventListener('change', onChange);
  return () => {
    phoneList.removeEventListener('change', onChange);
    tabletList.removeEventListener('change', onChange);
  };
}
export function useBreakpoint() {
  return useSyncExternalStore(subscribe, resolveBreakpoint, resolveBreakpoint);
}